import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UserCreateDto } from 'src/app/shared/dtos/user/userCreateDto';
import { UserUpdateDto } from 'src/app/shared/dtos/user/userUpdateDto';
import { UserType } from 'src/app/shared/enums/userType';
import { UsersService } from 'src/app/shared/services';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
@Component({
  templateUrl: 'profile.component.html',
  styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit {

  constructor(private usersService: UsersService,
    private loadingService: LoadingService,
    private notificationService: NotificationService,
  ) { }

  userTypes: any = [];
  users: Array<{ id: number, name: string }> = [];
  emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  ngOnInit(): void {
    this.getList()

    this.userTypes = Object.entries(UserType)
      .filter(([key, value]) => isNaN(Number(key)))
      .map(([name, id]) => ({ id, name }));


  }

  getList() {
    this.usersService.getList().subscribe(data => {
      this.users = data
    })
  }

  getById(id: number) {
    this.usersService.getById(id).subscribe()
  }
  async create(event: any) {
    let control = this.emailRegex.test(event.data.email)
    if(!control){
      this.notificationService.showError('Girilen mail adresi geçerli değil');
      this.getList()
      return
    }

    this.loadingService.show()
    var userCreateDto: UserCreateDto = {
      name: event.data.name,
      email: event.data.email,
      password: event.data.password,
      userType: event.data.userType
    }
    await firstValueFrom(this.usersService.create(userCreateDto))
    this.getList()
    this.notificationService.show('Başarı ile kaydedildi');
    this.loadingService.hide()
  }

  async update(event: any) {
    if( event.newData.email){
      let control = this.emailRegex.test(event.newData.email)
      if(!control){
        this.notificationService.showError('Girilen mail adresi geçerli değil');
        this.getList()
        return
      }
    }

    this.loadingService.show()
    if (event.newData) {
      var userUpdateDto: UserUpdateDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        email: event.newData.email ?? event.oldData.email,
        password: event.newData.password ?? event.oldData.password,
        userType: event.newData.userType ?? event.oldData.userType
      }
      await firstValueFrom(this.usersService.update(userUpdateDto.id, userUpdateDto))
      this.getList()
      this.notificationService.show('Başarı ile güncellendi');
    }
    this.loadingService.hide()
  }

  async delete(event: any) {
    this.loadingService.show()
    await firstValueFrom(this.usersService.delete(event.key))
    this.getList()
    this.notificationService.show('Başarı ile silindi');
    this.loadingService.hide()
  }

  renewPassword = async (event: any) => {
    this.loadingService.show();
    const newPassword = await firstValueFrom(this.usersService.renewPassword(event.row.data.id))
    this.notificationService.showCenter(`Yeni şifre: ${newPassword}`, { displayTime: 30000 })
    this.loadingService.hide()
  }
}
